import { render, staticRenderFns } from "./content-layout.vue?vue&type=template&id=0e4d11ba"
import script from "./content-layout.vue?vue&type=script&lang=js"
export * from "./content-layout.vue?vue&type=script&lang=js"
import style0 from "./content-layout.vue?vue&type=style&index=0&id=0e4d11ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports